import { toggleClass } from '@opten/dom/toggle-class';
class MapMarkerExtended {
    public marker: any;
    public className: any;
    constructor(element, className) {
        this.marker = element;
        this.className = className;
    }
}

export interface MapExtendedOptions {
    zoom?: number;
    draggable?: boolean;
    urlLocation?: string;
    urlDatacenter?: string;
    animation?: google.maps.Animation;
    mapStyles?: any;
    styledMapName?: string;
    mapMarkerClasses?: string[];
    showMapMarkerClasses?: string[];
    hasMapMarkerClassesButtonIfMultiple?: boolean;
    mapMarkerClassesButtonActiveClass?: string;
    mapMarkerInfoClass?: string;
    mapTypes?: google.maps.MapTypeId[];
    mapTypeControlStyle?: google.maps.MapTypeControlStyle;
    fitToBounds?: boolean;
}
export class MapExtended {
    private _options: MapExtendedOptions = {
        draggable: screen.width < 1025 === false,
        animation: google.maps.Animation.DROP,
        mapStyles: null,
        mapMarkerClasses: ['map-location'],
        showMapMarkerClasses: ['map-location'],
        hasMapMarkerClassesButtonIfMultiple: false,
        mapMarkerClassesButtonActiveClass: '--active',
        mapMarkerInfoClass: 'c-map-extended__information__marker',
        mapTypes: [
            google.maps.MapTypeId.ROADMAP,
            google.maps.MapTypeId.TERRAIN,
            google.maps.MapTypeId.SATELLITE,
            google.maps.MapTypeId.HYBRID
        ],
        mapTypeControlStyle: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        fitToBounds: true
    };
    private _mapMarkers = Array<MapMarkerExtended>();
    private _element: HTMLElement;
    private _currentInfoWindow = null;
    private _bounds: google.maps.LatLngBounds;

    constructor(element: HTMLElement, options: MapExtendedOptions) {
        this._element = element;
        this._options = { ...this._options, ...options };
        this.init();
        if (this._options.hasMapMarkerClassesButtonIfMultiple &&
            this._options.mapMarkerClasses.length > 1) {
            this._options.mapMarkerClasses
                .map(markerClass => document.getElementById(markerClass))
                .filter(markerElement => markerElement != null)
                .forEach(markerElement => markerElement.addEventListener('click', () => this.showHideMapMarkerClass(markerElement)));
        }
    }
    init() {
        if (typeof google === 'object' && typeof google.maps === 'object') {
            const id = this._element.getAttribute('data-map-id');
            const zoom = this._element.getAttribute('data-zoom');
            let mapZoom;
            if (typeof zoom == 'undefined' || zoom == null) {
                mapZoom = this._options.zoom;
            }
            else {
                mapZoom = zoom;
            }
            let lat;
            let lng;
            this._bounds = new google.maps.LatLngBounds();
            const mapTypes: any = this._options.mapTypes;
            if (this._options.mapStyles != null) {
                mapTypes.push('map_style');
            }
            const mapOptions = {
                zoom: +mapZoom,
                center: new google.maps.LatLng(lat, lng),
                draggable: true,
                mapTypeControlOptions: {
                    mapTypeIds: mapTypes,
                    style: this._options.mapTypeControlStyle
                }
            };
            const map = new google.maps.Map(document.getElementById(id), mapOptions);
            if (this._options.mapStyles != null) {
                const nameMap = this._options.styledMapName != null
                    ? this._options.styledMapName
                    : 'Map';
                const styledMap = new google.maps.StyledMapType(this._options.mapStyles, { name: nameMap });
                map.mapTypes.set('map_style', styledMap);
                map.setMapTypeId('map_style');
            }
            if (this._options.mapMarkerClasses != null &&
                this._options.mapMarkerClasses.length > 0) {
                this._options.mapMarkerClasses.forEach(markerClass => {
                    const markersClass = Array.from(this._element.getElementsByClassName(markerClass));
                    if (markersClass.length > 0) {
                        const showMarker = this._options.showMapMarkerClasses.indexOf(markerClass) > -1;
                        markersClass.forEach(markerClassInfo => this.createMarkerClass(markerClassInfo, markerClass, map, showMarker));
                    }
                });
            }
            if (this._options.fitToBounds) {
                map.fitBounds(this._bounds);
            }
            if (mapZoom != null && mapZoom > 0) {
                google.maps.event.addListenerOnce(map, 'idle', function () {
                    map.setZoom(+mapZoom);
                });
            }
        }
        else {
            console.error('Google Maps API is not included');
        }
    }
    createMarkerClass(markerClassInfo, markerClass, map, showMarker) {
        const markerInfoData = markerClassInfo;
        const dataCoordinates = markerInfoData.getAttribute('data-coordinates');
        const latlng = dataCoordinates.replace(' ', '').split(',');

        const mapMarkerIcon = markerInfoData.getAttribute('data-marker');
        const mapMarkerWidth = markerInfoData.getAttribute('data-marker-width');
        const mapMarkerHeight = markerInfoData.getAttribute('data-marker-height');
        const mapMarkerOriginX = markerInfoData.getAttribute('data-marker-origin-x');
        const mapMarkerOriginY = markerInfoData.getAttribute('data-marker-origin-y');
        const mapMarkerAnchorX = markerInfoData.getAttribute('data-marker-anchor-x');
        const mapMarkerAnchorY = markerInfoData.getAttribute('data-marker-anchor-y');
        const mapMarkerInfoArray = Array.from(markerInfoData.getElementsByClassName(this._options.mapMarkerInfoClass));
        let mapMarkerInfo = '';
        if (mapMarkerInfoArray.length > 0) {
            mapMarkerInfo = markerInfoData.innerHTML;
        }
        this.createMarker(latlng[0], latlng[1], mapMarkerIcon, mapMarkerWidth, mapMarkerHeight, mapMarkerOriginX, mapMarkerOriginY, mapMarkerAnchorX, mapMarkerAnchorY, mapMarkerInfo, map, showMarker, markerClass);
    }
    createMarker(lat, lng, mapMarkerIcon, mapMarkerWidth, mapMarkerHeight, mapMarkerOriginX, mapMarkerOriginY, mapMarkerAnchorX, mapMarkerAnchorY, mapMarkerInfo, map, showMarker, markerClass) {
        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(+lat, +lng),
            map: map,
            icon: {
                size: new google.maps.Size(+mapMarkerWidth, +mapMarkerHeight),
                origin: new google.maps.Point(+mapMarkerOriginX, +mapMarkerOriginY),
                anchor: new google.maps.Point(+mapMarkerAnchorX, +mapMarkerAnchorY),
                url: mapMarkerIcon
            },
            visible: showMarker
        });
        this._bounds.extend(marker.getPosition());
        if (mapMarkerInfo != '') {
            const infoWindow = new google.maps.InfoWindow({
                content: mapMarkerInfo
            });
            marker.addListener('click', () => {
                var wasCurrentWindow = this._currentInfoWindow != null && this._currentInfoWindow == infoWindow;
                if (this._currentInfoWindow != null) {
                    this._currentInfoWindow.close();
                }
                if (this._currentInfoWindow == null || this._currentInfoWindow !== infoWindow) {
                    infoWindow.open(map, marker);
                    this._currentInfoWindow = infoWindow;
                }
                else if (wasCurrentWindow) {
                    this._currentInfoWindow = null;
                }
            });
            marker.addListener('mouseover', () => {
                if (this._currentInfoWindow != null && this._currentInfoWindow !== infoWindow) {
                    this._currentInfoWindow.close();
                }
                if (this._currentInfoWindow == null || this._currentInfoWindow !== infoWindow) {
                    infoWindow.open(map, marker);
                    this._currentInfoWindow = infoWindow;
                }
            });

            /*marker.addListener('mouseout', function() {
                infoWindow.close();
            });*/
        }
        this._mapMarkers.push(new MapMarkerExtended(marker, markerClass));
    }
    showHideMapMarkerClass(button) {
        const className = button.id;
        toggleClass(button, this._options.mapMarkerClassesButtonActiveClass);
        const visible = button.classList.contains(this._options.mapMarkerClassesButtonActiveClass); // show if checked, otherwise hide
        if (className.length != null && className.length > 0) {
            this._mapMarkers
                .filter(mapMarker => mapMarker.className === className)
                .forEach(mapMarker => mapMarker.marker.setVisible(visible));
        }
    }
}

export default function mapExtended(
    element: HTMLElement,
    options: MapExtendedOptions
): MapExtended {
    return new MapExtended(element, options);
}
